import styled from 'styled-components';
import { devices, theme } from '@/styles/theme/index.jsx';

export const StyledContactForm = styled.section`
    position: relative;
    padding: 120px 0;
    background: ${theme.colors.hover};
	margin-top: -1px;

    .location-address-wrapper {
        background: ${theme.colors.white};
        max-height: 100svh;
        overflow: auto;
        scroll-snap-type: y mandatory;
        &::-webkit-scrollbar {
            width: 3px;
        }

        /* Track */
        &::-webkit-scrollbar-track {
            background: ${theme.colors.scrollBar};
        }

        /* Handle */
        &::-webkit-scrollbar-thumb {
            background: ${theme.colors.menuList};
        }

        /* Handle on hover */
        &::-webkit-scrollbar-thumb:hover {
            background: ${theme.colors.scrollBarThumb};
        }
		
        .location {
            text-align: center;
            background: ${theme.colors.secondaryGreen};
            padding: 10px;

            h3 {
                color: ${theme.colors.white};
                ${theme.fontGroup24}
            }
        }

        ul {
            margin: 0;
            padding: 0;

            li {
                display: flex;
                flex-wrap: wrap;
                border-bottom: 1px solid ${theme.colors.secondaryGreen200};
                padding: 45px 45px 25px;

                .image-wrap-button {
                    width: 35%;
                    flex: 0 0 35%;

                    .image-wrapper {
                        position: relative;
                        padding-top: ${theme.googleMapRatio};

                        ${devices.xxl} {
                            padding-top: ${theme.googleMapRatioMobile};
						}
                    }

                    .click_to_see {
                        text-align: center;
                        margin-top: 10px;
                        color: ${theme.colors.secondaryGreen300};
                        ${theme.clickToSee}
                    }
                }

                .content_info {
                    width: 65%;
                    flex: 0 0 65%;
                    padding-left: 25px;

                    h4 {
                        margin-bottom: 25px;
                        color: ${theme.colors.googleMapContent};
                        ${theme.fontGroup24}
                    }

                    .address {
                        display: flex;
                        flex-direction: column;
                        gap: 20px;

                        .item {
                            display: flex;
                            gap: 10px;
                            color: ${theme.colors.secondaryGreen400};

                            .icon {
                                width: 20px;
                            }

                            p {
                                color: ${theme.colors.secondaryGreen400};
                                ${theme.mainFont500}
                            }

                            a {
                                color: ${theme.colors.secondaryGreen400};
                                ${theme.mainFont500}
                            }
                        }
                    }

                }

            }
        }
		
    }

    .google-map-wrapper {
        height: 100%;
		position: relative;
		
		.image-wrapper{
            overscroll-behavior-y: contain;
            padding-top: ${theme.googleMapRatioModal};
            ${theme.fullHeightWidth}
            ${theme.absoluteFill}
			opacity: 0;
			visibility: hidden;
			overflow: hidden;
            transition: ${theme.transition};

            &.active{
                ${theme.visibilityVisible}
                iframe {
                    ${theme.visibilityVisible}
                }
				&:after{
                    ${theme.visibilityHidden}
                    z-index: -1;
				}
			}

            &:after{
                ${theme.fullHeightWidth}
                ${theme.absoluteFill}
                background: ${theme.colors.black50};
                transition: ${theme.transition};
                z-index: 33;
                content: '';
            }
			iframe{
                ${theme.fullHeightWidth}
                ${theme.absoluteFill}
                transition: ${theme.transition};
                object-fit: cover;
                z-index: 9;
                opacity: 0;
                visibility: hidden;
			
				&:hover{
					pointer-events: all;
				}
			}
			
			
		}
		
		
        .click_to_see {
            margin-top: 10px;
            color: ${theme.colors.secondaryGreen300};
            ${theme.clickToSee}
			text-decoration: underline;
			cursor: pointer;
        }
        > div {
            height: 100% !important;
        }
		
		.info-window-custom{
			
		}
    }


    ${devices.md} {
		.col-md-6{
			width: 100%;
			padding: 0 15px !important;
		}
        .location-address-wrapper {
            background: ${theme.colors.white};
            overflow-y: scroll;
            max-height: 50svh;
        }
        .google-map-wrapper{
			min-height: 550px;
		}
    }

    ${devices.sm} {
        padding: 95px 0;
		.image-wrap-button{
			display: none;
		}
        .location-address-wrapper ul li{
			padding: 25px;
		}
        .content_info {
            width: 100% !important;
            flex: 0 0 100% !important;
            padding-left: 0 !important;
        }
	}

`;
